module.exports = __webpack_public_path__ + "static/img/South Korea.33af5e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flag/South Korea.png
// module id = 3+Fm
// module chunks = 1